import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import './App.scss'
import ScrollToTop from "./ScrollToTop";


const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
        
        <BrowserRouter>
        <React.StrictMode>
                <ScrollToTop />
                        <App />
        </React.StrictMode>
        </BrowserRouter>
);



